/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type MenuReorderRailOrdersQueryVariables = Types.Exact<{
  input: Types.OrdersInputV2;
  restaurantId: Types.Scalars['Int']['input'];
}>;

export type MenuReorderRailOrdersQuery = {
  readonly __typename?: 'Query';
  readonly ordersV2:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename: 'Order';
          readonly id: string;
          readonly isCanceled: boolean;
          readonly isPendingFeedback: boolean;
          readonly wantedTime: string;
          readonly hasEarnedLoyaltyPoints: boolean;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly slug: string;
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly customName: string | null;
            readonly canReorderAtRestaurant: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly orderParticipant: {
              readonly __typename?: 'OrderParticipant';
              readonly id: string;
              readonly isMe: boolean;
            } | null;
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly weight: Types.DressingWeight;
              readonly ingredientId: string;
            }>;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly categoryName: string;
              readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
          }>;
        }>;
      }
    | { readonly __typename: 'ValidationError' };
};

export const MenuReorderRailOrdersDocument = gql`
  query menuReorderRailOrders($input: OrdersInputV2!, $restaurantId: Int!) {
    ordersV2(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        orders {
          id
          __typename
          isCanceled
          isPendingFeedback
          wantedTime
          hasEarnedLoyaltyPoints
          restaurant {
            id
            __typename
            name
            slug
          }
          deliveryOrderDetail {
            id
            __typename
            tip
            deliveryFee
            vendor
            orderId
            vendorRestaurantId
            estimatedDeliveryTime
            address {
              id
              __typename
              street
              secondaryStreet
              city
              state
              country
              zipCode
              deliveryPreference
              googlePlaceId
              latitude
              longitude
              name
              notes
            }
          }
          lineItems {
            id
            __typename
            customName
            canReorderAtRestaurant(restaurantId: $restaurantId)
            orderParticipant {
              id
              isMe
            }
            dressingMode
            mixedDressingDetails {
              weight
              ingredientId
            }
            addedIngredients {
              id
              __typename
              name
              kind
            }
            removedIngredients {
              id
              __typename
              name
              kind
            }
            product {
              id
              __typename
              name
              isCustom
              categoryName
              asset {
                url
              }
              ingredients {
                id
                __typename
                name
                kind
              }
            }
          }
        }
      }
    }
  }
`;

export function useMenuReorderRailOrdersQuery(
  options: Omit<Urql.UseQueryArgs<MenuReorderRailOrdersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<MenuReorderRailOrdersQuery, MenuReorderRailOrdersQueryVariables>({
    query: MenuReorderRailOrdersDocument,
    ...options,
  });
}
